import {
	RecordContextProvider,
	ReferenceField,
	TextField,
	useTranslate
} from 'react-admin';
import { Link } from 'react-router-dom';
import {
	LocationOnRounded,
	MonetizationOn,
	SquareFoot
} from '@mui/icons-material';
import {
	Box,
	Card,
	CardActionArea,
	CardActions,
	CardContent,
	CardMedia,
	List,
	ListItem,
	ListItemText,
	Typography
} from '@mui/material';
import { AddToFavoritesButton } from '../../../components';
import {
	INPUT_SOURCE,
	OBJECT_STATUSES_ID_MAP,
	OBJECTS_TYPES
} from '../../../constants';
import { useObjectStatuses } from '../../../hooks';
import { ApartmentType } from '../../../types';

export const ApartmentCard = ({ data }: { data: ApartmentType }) => {
	const {
		name,
		area,
		id,
		rent_usd_object_price,
		sale_usd_object_price,
		avatar,
		status_data: statusData
	} = data;

	const { status_id: statusId } = statusData || {};
	const { getObjectStatus } = useObjectStatuses();
	const { color: statusColor, name: statusName } =
		getObjectStatus(statusId || 1) || {};

	const t = useTranslate();

	return (
		<RecordContextProvider value={data}>
			<Card
				sx={{
					position: 'relative',
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					textDecoration: 'none'
				}}
			>
				<CardActions
					disableSpacing={true}
					sx={{
						position: 'absolute',
						right: 0,
						top: 0,
						zIndex: 3
					}}
				>
					<Box
						sx={{
							position: 'absolute',
							top: 0,
							right: 0,
							backgroundColor: 'rgba(255, 255, 255, .8)',
							borderRadius: '0 0 0 8px',
							boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3)',
							padding: '4px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center'
						}}
					>
						{/*<AddToFavoritesButton resource="apartments" />*/}
					</Box>
				</CardActions>
				{[OBJECT_STATUSES_ID_MAP.RENTED, OBJECT_STATUSES_ID_MAP.SOLD].includes(
					statusId || 0
				) && (
					<Box
						sx={{
							position: 'absolute',
							top: 54,
							right: '50%',
							transform: 'translateX(50%)',
							backgroundColor: statusColor,
							color: '#fff',
							px: 1.5,
							py: 0.5,
							borderRadius: '4px',
							fontWeight: 'bold',
							zIndex: 1
						}}
					>
						{statusName}
					</Box>
				)}
				<CardActionArea
					component={Link}
					to={`/objects/${OBJECTS_TYPES.APARTMENTS}/show/${id}`}
					sx={{
						height: '100%',
						...([
							OBJECT_STATUSES_ID_MAP.RENTED,
							OBJECT_STATUSES_ID_MAP.SOLD
						].includes(statusId || 0) && {
							opacity: 0.5,
							filter: 'grayscale(0.5)'
						})
					}}
				>
					<CardMedia
						component="img"
						height="140"
						image={
							avatar && avatar.src
								? avatar.src
								: 'https://www.thespruce.com/thmb/BpZG-gG2ReQwYpzrQg302pezLr0=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Stocksy_txp3d216bb1tUq300_Medium_4988078-56c96ac19def4bf8ba430cf5063b6b38.jpg'
						}
						alt="apartment_image"
					/>
					<CardContent
						sx={{
							padding: 1
						}}
					>
						<Typography noWrap variant="h6" component="div">
							{name}
						</Typography>
						<List>
							<ListItem disablePadding={true}>
								<SquareFoot />
								<ListItemText
									slotProps={{
										primary: {
											fontSize: 16,
											fontWeight: 'medium'
										}
									}}
									sx={{ marginLeft: 1 }}
									primary={`${area} м²`}
								/>
							</ListItem>
							{sale_usd_object_price && (
								<ListItem disablePadding={true}>
									<MonetizationOn color="error" />
									<ListItemText
										slotProps={{
											primary: {
												fontSize: 16,
												fontWeight: 'medium'
											}
										}}
										sx={{ marginLeft: 1 }}
										primary={`Продаж: ${sale_usd_object_price} $`}
									/>
								</ListItem>
							)}
							{rent_usd_object_price && (
								<ListItem disablePadding={true}>
									<MonetizationOn color="success" />
									<ListItemText
										slotProps={{
											primary: {
												fontSize: 16,
												fontWeight: 'medium'
											}
										}}
										sx={{ marginLeft: 1 }}
										primary={`Оренда: ${rent_usd_object_price} $`}
									/>
								</ListItem>
							)}
							<ListItem disablePadding={true}>
								<LocationOnRounded color="primary" />
								<ListItemText sx={{ marginLeft: 1 }}>
									<ReferenceField
										source={INPUT_SOURCE.BUILDING_ID}
										reference={OBJECTS_TYPES.BUILDINGS}
										link={false}
									>
										<TextField
											source="address"
											sx={{ fontSize: 16, fontWeight: 'medium' }}
										/>
									</ReferenceField>
								</ListItemText>
							</ListItem>
						</List>
					</CardContent>
				</CardActionArea>
			</Card>
		</RecordContextProvider>
	);
};
